export enum Permission {
  CaseDeleteAny = 'case:delete-any',

  UsersManage = 'users:manage',

  MatterManageUsers = 'matter:manage-users',
  MatterViewAll = 'matter:view-all',

  IntegrationsManage = 'integrations:manage',
  TokenLimitsManage = 'token-limits:manage',
  ApproveRuns = 'runs:approve',

  RealtimeUse = 'realtime:use',

  RelativityImport = 'relativity:import',

  UsageDashboardView = 'usage-dashboard:view',
}
